import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DashCardBlue from '../components/DashCardBlue';
import DummyLineChart from '../components/DummyLineChart';
const TotalQualifyingRndExpenditure = _ref => {
  let {
    dashboardData
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderCardBody = () => {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 7,
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-truncate mb-0"
    }, window.MARKET_CONSTANTS.CURRENCY_SYMBOL, window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(Math.round(dashboardData.total_qualifying_rnd_expenditure)))), /*#__PURE__*/React.createElement(Col, {
      xs: 5,
      className: "align-self-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center",
      style: {
        height: '75px'
      }
    }, /*#__PURE__*/React.createElement(DummyLineChart, null))));
  };
  return /*#__PURE__*/React.createElement(DashCardBlue, {
    titleIcon: "pie_chart",
    title: t(`chart_title_cumulative_qe_to_date`),
    body: renderCardBody()
  });
};
export default TotalQualifyingRndExpenditure;